import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";
import {AnswerSchemaModel} from "./answer-schema-model";

export class QuestionSchemaDataModel extends BaseSchemaDataModel {
  question: String;
  answer: String;
}

export class QuestionSchemaModel extends BaseSchemaModel {
  model: QuestionSchemaDataModel;

  constructor(model: QuestionSchemaDataModel) {
    super(SCHEMA_TYPE.question, model.question);

    this.model = model;
  }

  get typeParams(): String {
    return this.type ? `"@type":"${this.type}"` : `` ;
  }

  get nameParams() {
    return super.nameParams.fromHtmlToText()
  }

  get answerParams(): String {
    return this.model.answer ? `,"acceptedAnswer":${(new AnswerSchemaModel({answer: this.model.answer.toString().fromHtmlToText()})).toString()}` : ``;
  }

  toString(): String {
    return `{${this.typeParams}${this.nameParams.fromHtmlToText()}${this.answerParams}}`;
  }
}
